import { TranslateUnauthenticatedPipe } from '../../../filters/translate-unauthenticated.pipe';
import { ItemErrorComponent } from '../../../components/item-form-error/item-form-error.component';
import { ItemFormErrorWithTranslatorComponent } from '../../../components/item-form-error-with-translator/item-form-error-with-translator.component';
import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { SiffiLanguagePickerComponent } from '../../../components/siffi-language-picker/siffi-language-picker.component';
import Session from '../../../utils/session.service';
import Config from '../../../utils/config.service';
import UserRestServices from '../../../services/user-rest.service';
import LanguageService from '../../../services/language.service';
import AngularHelperService from '../../../services/angular-helper.service';
import AngularFilterHelperService from '../../../services/angular-filter-helper.service';
import AngularRoutingHelperService from '../../../services/angular-routing-helper.service';
import ScreeningEscalationRestService from '../../../services/screening-escalation-rest.service';
import { MatSelectModule } from '@angular/material/select';
import { Subscription } from 'rxjs';
import AppLanguageService from '../../../services/app-language.service';

@Component({
	standalone: true,
	selector: 'register',
	templateUrl: './register.component.html',
	styleUrl: '../auth-public.scss',
	imports: [
		CommonModule, MatSelectModule, TranslateUnauthenticatedPipe, RouterLink,
		ItemErrorComponent, ItemFormErrorWithTranslatorComponent, FormsModule,
		SiffiLanguagePickerComponent
	]
})
export default class RegisterView implements OnInit, OnDestroy {
	private readonly roleTypes: any = {
		COMPANY: 'COMPANY',
		INDIVIDUAL: 'INDIVIDUAL',
		HSP: 'HSP'
	};

	private session: Session = inject(Session);
	private config: Config = inject(Config);
	private userRestServices: UserRestServices = inject(UserRestServices);
	private languageService: LanguageService = inject(LanguageService);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private angularFilterHelperService: AngularFilterHelperService = inject(AngularFilterHelperService);
	private angularRoutingHelperService: AngularRoutingHelperService = inject(AngularRoutingHelperService);
	private appLanguageService: AppLanguageService = inject(AppLanguageService);
	private screeningRest: ScreeningEscalationRestService = inject(ScreeningEscalationRestService);

	vm: any = undefined;
	watcher: any = undefined;
	private titleSubscription: Subscription = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		this.vm.countries = this.config.getCountries().map((item) => {
			return {
				label: item.name,
				value: item.code
			};
		});

		var queryParams: any = this.angularRoutingHelperService.getQueryParams();
		this.determineLocation(queryParams);
		this.vm.isMobileView = window.matchMedia('(max-width: 768px)').matches;
		this.vm.screeningToken = queryParams['screeningToken'] || this.screeningRest.getPilotToken();
		this.vm.screeningOrg = queryParams['screeningOrg'] || this.screeningRest.getPilotOrg();
		this.vm.isScreeningRegistration = !!this.vm.screeningToken;

		this.vm.isLanguageMenuOpen = false;
		this.vm.locale = this.appLanguageService.normalizeLocale(queryParams['locale'] || window.sessionStorage.getItem('locale') || 'en_GB');
		this.vm.logoSuffix = this.resolveLogoSuffix(this.vm.locale);
		this.vm.localeParams = this.getRouteParams();
		if (this.vm.isScreeningRegistration) {
			this.screeningRest.savePilotContext(this.vm.screeningToken, this.vm.screeningOrg, this.vm.locale);
		}
		window.sessionStorage.setItem("locale", this.vm.locale);
		this.vm.locales = this.appLanguageService.getLanguagesByOrigin(this.vm.origin);
		this.vm.languages = this.config.getSettings().Languages;
		var currentSession = this.session.getSession();
		this.vm.isAuthenticated = !!currentSession;
		if (this.vm.isAuthenticated) {
			this.angularRoutingHelperService.home(currentSession.user);
			return;
		}
		
		this.vm.navigateToRoot = this.navigateToRoot;
		this.vm.registerCompany = this.registerCompany;
		this.vm.registerIndividual = this.registerIndividual;
		this.vm.registerHsp = this.registerHsp;
		this.vm.registerScreeningParticipant = this.registerScreeningParticipant;
		this.vm.setLocale = this.setLocale;
		this.vm.toggleLangMenu = this.toggleLangMenu;
		this.vm.getLocaleOption = this.getLocaleOption;
		this.vm.onRoleChange = this.onRoleChange;
		if (this.vm.isScreeningRegistration) {
			this.vm.role = this.roleTypes.INDIVIDUAL;
			this.vm.isIndividualRole = true;
		}

		this.getLanguages();
		this.getRoles();
		this.applyRoleFromQueryParams(queryParams);

		//this.vm.isCompanyRole = this.vm.role;
		this.angularHelperService.element(this.angularHelperService.getWindow()).on('resize', () => { this.vm.isMobileView = window.matchMedia('(max-width: 768px)').matches;});
		this.titleSubscription = this.angularFilterHelperService.watchDocumentTitleUnauthenticated('Register.Register_Title_Green');
	}
	
	ngOnDestroy() {
		if (this.titleSubscription) {
			this.titleSubscription.unsubscribe();
		}
		if (this.watcher) {
			this.angularHelperService.cancelInterval(this.watcher);
		}
	}
	
	navigateToRoot($event) {
		$event.preventDefault();
		window.location.href = this.config.getPublicWebHomeUrl(this.vm.origin, this.vm.locale);
	}
	
	setLocale(locale) {
		this.angularRoutingHelperService.setQueryParam('locale', locale);
		setTimeout(() => {
			window.location.reload();
		}, 300);
	}
	
	getLanguages() {
		this.languageService.getAvailableLanguages().subscribe((response) => {
			var languages: any = response;
			var serviceLanguages: any = languages['serviceLanguages'].map((item) => {
				return {
					label: item.name,
					value: item['languageCode']
				};
			});
			var addingLanguages: any = languages['addingLanguages'].map((item) => {
				return {
					label: item.name,
					value: item['languageCode']
				};
			});
			this.vm.languageList = serviceLanguages.concat(addingLanguages);
		});
	}

	getRoles() {
		this.vm.roleList = [
			{ value: this.roleTypes.COMPANY, translationKey: 'Register.As_Company' },
			{ value: this.roleTypes.INDIVIDUAL, translationKey: 'Register.As_Individual_Employee' },
			{ value: this.roleTypes.HSP, translationKey: 'Register.As_Service_Provider' }
		];
	}

	onRoleChange(updateQueryParam = true) {
		this.vm.isCompanyRole = this.vm.role === this.roleTypes.COMPANY;
		this.vm.isIndividualRole = this.vm.role === this.roleTypes.INDIVIDUAL;
		this.vm.isHspRole = this.vm.role === this.roleTypes.HSP;
		if (updateQueryParam && this.vm.role) {
			this.angularRoutingHelperService.setQueryParam('role', this.vm.role);
		}
	}
	
	registerCompany(companyForm: any) {
		this.vm.companyFormSubmitted = true;
		if (this.vm.loading || companyForm.invalid) return;
		this.vm.loading = true;
		var credentials: any = {
			businessName: this.vm.companyName,
			contactName: this.vm.fullName,
			contactPhone: this.vm.companyPhone,
			contactEmail: this.vm.companyEmail,
			origin: this.vm.origin,
			deviceLanguage: this.vm.locale
		}
		this.userRestServices.signupBusiness(credentials).then(
			(response) => {
				if (response.status === 200) {
					this.vm.loading = false;
					this.vm.registrationSuccessful = true;
					this.vm.registrationError = false;
				} else {
					this.vm.loading = false;
					this.vm.registrationError = true;
				}
			},
			(err) => {
				this.vm.loading = false;
				this.vm.registrationError = true;
				console.log(err);
			}
		);
	}
	
	registerIndividual(individualForm: any) {
		if (this.vm.isScreeningRegistration) {
			return this.registerScreeningParticipant(individualForm);
		}
		this.vm.individualFormSubmitted = true;
		if (this.vm.loading || individualForm.invalid) return;
		if (this.vm.individualPassword != this.vm.individualPasswordConfirm) {
			this.vm.passwordMismatch = true;
			return;
		} else {
			this.vm.passwordMismatch = false;
		}
		this.vm.loading = true;
		
		var credentials: any = {
			firstName: this.vm.fullName.split(' ')[0],
			lastName: this.vm.fullName.split(' ')[1],
			email: this.vm.individualEmail,
			password: this.vm.individualPassword,
			passConf: this.vm.individualPasswordConfirm,
			origin: this.vm.origin,
			deviceLanguage: this.vm.locale
		}
		this.userRestServices.emailAvailable({ email: this.vm.individualEmail }).then(
			(response) => {
				if (response.status === 200) {
					this.userRestServices.signup(credentials).then(
						(res) => {
							console.log(res);
							if (res.status === 200) {
								this.vm.loading = false;
								this.vm.registrationSuccessful = true;
								this.vm.registrationError = false;
								this.vm.confirmationLinkSent = true;
							} else {
								this.vm.loading = false;
								this.vm.registrationError = true;
							}
						},
						(err) => {
							this.vm.loading = false;
							this.vm.registrationError = true;
							console.log(err);
						}
					);
				} else {
					this.vm.loading = false;
					this.vm.registrationError = true;
					console.log("Email already registered. Please try again.");
				}
			},
			(err) => {
				this.vm.loading = false;
				this.vm.registrationError = true;
				console.log(err);
			}
		);
		
	}

	registerScreeningParticipant(individualForm: any) {
		this.vm.individualFormSubmitted = true;
		if (this.vm.loading || individualForm.invalid) return;
		this.vm.loading = true;
		var fullNameParts: Array<any> = (this.vm.fullName || '').trim().split(/\s+/).filter((part) => !!part);
		var firstName: any = fullNameParts.length > 0 ? fullNameParts[0] : undefined;
		var lastName: any = fullNameParts.length > 1 ? fullNameParts.slice(1).join(' ') : undefined;
		this.screeningRest.savePilotContext(this.vm.screeningToken, this.vm.screeningOrg, this.vm.locale);
		this.userRestServices.requestScreeningRegistration({
			email: this.vm.individualEmail,
			token: this.vm.screeningToken,
			firstName: firstName,
			lastName: lastName,
			deviceLanguage: this.vm.locale
		}).then(() => {
			this.vm.loading = false;
			this.vm.registrationSuccessful = true;
			this.vm.registrationError = false;
			this.vm.confirmationLinkSent = true;
		}).catch((err) => {
			this.vm.loading = false;
			this.vm.registrationError = true;
			console.log(err);
		});
	}
	
	registerHsp(serviceProviderForm: any) {
		this.vm.serviceProviderFormSubmitted = true;
		if (this.vm.loading || serviceProviderForm.invalid || !this.vm.countryOfResidence || !this.vm.languageCode) return;
		this.vm.loading = true;
		var credentials: any = {
			contactName: this.vm.fullName,
			contactEmail: this.vm.hspEmail,
			contactPhone: this.vm.hspPhone,
			languageCode: this.vm.languageCode?.label,
			additionalLanguageCode: this.vm.additionalLanguageCode?.label,
			education: this.vm.education,
			businessName: this.vm.fullName,
			additionalInfo: this.vm.description,
			healthServiceProvider: true,
			origin: this.vm.origin,
			deviceLanguage: this.vm.locale
		};
		this.userRestServices.signupBusiness(credentials).then(
			(response) => {
				if (response.status === 200) {
					this.vm.loading = false;
					this.vm.registrationSuccessful = true;
					this.vm.registrationError = false;
				} else {
					this.vm.loading = false;
					this.vm.registrationError = true;
				}
			},
			(err) => {
				this.vm.loading = false;
				this.vm.registrationError = true;
				console.log(err);
			}
		);
	}

	toggleLangMenu() {
		this.vm.isLanguageMenuOpen = !this.vm.isLanguageMenuOpen;
	}

	getLocaleOption(locale) {
		return this.appLanguageService.getLanguage(locale);
	}

	private getRouteParams() {
		var params: any = this.vm.locale ? { locale: this.vm.locale } : {};
		if (this.vm.origin && this.vm.origin !== 'siffi.com') {
			params.origin = this.vm.origin;
		}
		return params;
	}

	private applyRoleFromQueryParams(queryParams) {
		var requestedRole: any = this.resolveRoleFromQueryParam(queryParams && queryParams['role']);
		if (requestedRole) {
			this.vm.role = requestedRole;
		}
		this.onRoleChange(false);
	}

	private resolveRoleFromQueryParam(roleParam) {
		if (!roleParam) {
			return undefined;
		}
		var normalizedRole: any = String(Array.isArray(roleParam) ? roleParam[0] : roleParam).trim().toLowerCase().replace(/[\s_-]/g, '');
		var roleAliases: any = {
			company: this.roleTypes.COMPANY,
			business: this.roleTypes.COMPANY,
			businessclient: this.roleTypes.COMPANY,
			hr: this.roleTypes.COMPANY,
			individual: this.roleTypes.INDIVIDUAL,
			employee: this.roleTypes.INDIVIDUAL,
			enduser: this.roleTypes.INDIVIDUAL,
			user: this.roleTypes.INDIVIDUAL,
			hsp: this.roleTypes.HSP,
			serviceprovider: this.roleTypes.HSP,
			healthserviceprovider: this.roleTypes.HSP,
			provider: this.roleTypes.HSP,
			coach: this.roleTypes.HSP,
			therapist: this.roleTypes.HSP
		};
		return roleAliases[normalizedRole];
	}

	private determineLocation(queryParams) {
		var host: any = window.location.hostname;
		var url: any = window.location.href;
		var requestedOrigin: any = queryParams['origin'];
		if (host.includes('minudoc')) {
			this.vm.origin = host.includes('minudoc.fi') ? 'minudoc.fi' : 'minudoc.ee';
			this.vm.product = url.includes('eelvisiit') ? 'PREVISIT' : 'MINUDOC';
			this.vm.headerClass = '';
			this.vm.brandName = this.vm.product === 'PREVISIT' ? 'eelvisiit' : 'MinuDoc';
			return;
		}
		if (requestedOrigin && requestedOrigin.includes('minudoc')) {
			this.vm.origin = requestedOrigin;
			this.vm.product = 'MINUDOC';
			this.vm.headerClass = '';
			this.vm.brandName = 'MinuDoc';
			return;
		}
		this.vm.origin = host.includes('siffi') ? 'siffi.com' : (requestedOrigin || 'siffi.com');
		this.vm.product = 'SIFFI';
		this.vm.headerClass = 'o-container c-container';
		this.vm.brandName = 'Siffi';
	}

	private resolveLogoSuffix(locale: string) {
		var normalizedLocale: any = this.appLanguageService.normalizeLocale(locale);
		var languageCode: any = (normalizedLocale || 'en_GB').split('_')[0];
		if (['en', 'et', 'ru', 'fi'].indexOf(languageCode) === -1) {
			return 'en';
		}
		return languageCode;
	}

}
